import { useQuery } from "@tanstack/react-query";
import { API_TOURS } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchExperiences = () => {
  return useQuery({
    queryKey: ["experiences"],
    queryFn: () => fetcher(API_TOURS),
    select: (response) => response?.data ?? [],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
